import { render, staticRenderFns } from "./OffersIcon.vue?vue&type=template&id=20cefe8d&"
import script from "./OffersIcon.vue?vue&type=script&lang=js&"
export * from "./OffersIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports